import type { DeathAction } from './api/lifecycle.ts';

/** When a death's task is due, in words (159, P-27): the next business day, or within so many days of the death. */
export function deathActionDue(a: DeathAction): string {
  if (a.due_rule === 'next_business_day' || a.due_within_days === null) return 'the next business day';
  return `within ${a.due_within_days} ${a.due_within_days === 1 ? 'day' : 'days'}`;
}

/** Who a death's task goes to, in words (159): the client's case manager in the department or its queue, or the queue. */
export function deathActionHolder(a: DeathAction): string {
  return a.assign_to === 'queue' ? `${a.department} queue` : `${a.department} case manager (or the queue)`;
}
